// extracted by mini-css-extract-plugin
module.exports = {"basicPlan":"Index_basicPlan_dqglv"};